import React from 'react';
import type { ForYouConfig } from '@atlassian/global-side-navigation';
import { MENU_ID_FOR_YOU } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { jiraHomeRoute } from '@atlassian/jira-router-routes-jira-home-routes/src/jiraHomeRoute.tsx';
import { oldJiraHomeRoute } from '@atlassian/jira-router-routes-jira-home-routes/src/oldJiraHomeRoute.tsx';
import { SkeletonNavMenuItems } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { AnalyticContextProvider } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-recent/src/common/controllers/analytic-context/index.tsx';
import { useRecentItems } from '../../../controllers/use-recent-items/useRecentItems.tsx';
import { recentFlyoutEntrypoint } from '../recent/entrypoint.tsx';
import { RecentMenuLinkItemAdaptor } from '../recent/RecentMenuLinkItemAdaptor.tsx';
import type { JiraOLFItem } from '../../types.tsx';

type Params = {
	recentEntryPointParams?: Record<string, unknown>;
};

export function getForYouConfig({ recentEntryPointParams }: Params): ForYouConfig<JiraOLFItem> {
	const jiraHomePathToUse = fg('blu-7514_update_jira_home_your_work_to_for_you')
		? jiraHomeRoute.path
		: oldJiraHomeRoute.path;

	return {
		forYouItem: {
			menuItemId: MENU_ID_FOR_YOU,
			url: jiraHomeRoute.path,
		},
		recent: {
			entryPoint: recentFlyoutEntrypoint,
			entryPointParams: recentEntryPointParams,
			isSearchable: true,
			fallback: (
				<SkeletonNavMenuItems withHeading withSearch withSubHeading withSubTitle isFlyout />
			),
			ItemComponent: RecentMenuLinkItemAdaptor,
			menuItemId: 'global.recent',
			MenuContentWrapperComponent: AnalyticContextProvider,
			useItems: useRecentItems,
			viewAllUrl: `${jiraHomePathToUse}?viewed`,
		},
	};
}
